import { Paths } from "src/constants/paths";

export const menuItems: { name: string; path: string }[] = [
  { name: "Prices", path: Paths.PRICES },
  { name: "Intakes", path: Paths.INTAKES },
  { name: "Medications", path: Paths.PRODUCT_MEDICATIONS },
];
